import React, { useEffect, useState } from 'react';
import axios from 'axios';
import $ from 'jquery';
//import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import './CustomDataTableStyles.css'; // Import custom CSS
import { MDBInputGroup, MDBInput, MDBIcon, MDBBtn, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { Link, useNavigate, Navigate, Routes } from 'react-router-dom'

const Home = () => {

    let navigate = useNavigate()
    const handleForgotPassword = async e => {
      navigate('/ForgotPassword')
    }

    const server_app_api_php = window.SERVER_APP_API_PHP;
    const [showPassword, setShowPassword] = useState(false);
    const [plotsRidgehill, setPlotsRidgehill] = useState([]);
    const [plotsHardstone, setPlotsHardstone] = useState([]);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [entriesPerPageHardstone, setEntriesPerPageHardstone] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);    

    useEffect(() => {
        const carousel = document.querySelector('#carouselExampleSlidesOnly');
        const bsCarousel = new window.bootstrap.Carousel(carousel, {
            interval: 5000,
        });
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const textContainerStyleSmall = {
        position: 'relative',
        zIndex: 1,
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        padding: '20px',
    };


    const handleLogin = async (event) => {
        event.preventDefault();

        if (username.trim() !== '' && password.trim() !== '') {
            setLoading(true);
            const formData = new FormData();
            formData.append('apiType', 'login');
            formData.append('username', username.trim());
            formData.append('password', password.trim());
            

            try {
                const response = await axios.post(`${server_app_api_php}/server/index.php`, formData);
                const data = response.data;
                //alert(data)
                if (response.data.status === "LoggedIn") {
                    const sessionData = data.sessionData;      
                    localStorage.setItem('userName', sessionData.userName);
                    localStorage.setItem('userID', sessionData.userID);
                    localStorage.setItem('companyID', sessionData.companyID);
                    localStorage.setItem('businessLocationID', sessionData.businessLocationID);
                    localStorage.setItem('userPosition', sessionData.userPosition);
                    localStorage.setItem('userRole', sessionData.userRole);
                    localStorage.setItem('userType', sessionData.userType);
                    localStorage.setItem('email', sessionData.email);
                    localStorage.setItem('business_locationIDMain', "");
                    setUsername('');
                    setPassword('');
                    window.location.href = "Dashboard";
                    //alert("Logged in .. Redirecting.......");
                } else {
                    alert("Failed To Login");
                }
            } catch (error) {
                alert("There seems to be a problem with your internet connectivity. If this problem continues, kindly contact support team");
            } finally {
                setLoading(false);
            }
        } else {
            alert('Please fill all fields.');
            setLoading(false);
        }
    };


    useEffect(() => {
        const fetchDataRidgehill = async () => {
            const formData = new FormData();
            formData.append('apiType', 'fetchUnsoldRidgehillPlots');
            try {
                const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                setPlotsRidgehill(response.data);
                
                setTimeout(() => {
                    initializeDataTable('#ridgehillPlots');
                }, 1000); // Reduced timeout for quicker feedback
            } catch (error) {
               // console.error('There was an error fetching the data!', error);
            }
        };
        fetchDataRidgehill();
    }, []);

    useEffect(() => {
        const fetchDataHardstone = async () => {
            const formData = new FormData();
            formData.append('apiType', 'fetchUnsoldHardstonePlots');
            try {
                const response = await axios.post(`${server_app_api_php}/server/index.php`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                setPlotsHardstone(response.data);
                
                setTimeout(() => {
                    initializeDataTable('#hardstonePlots');
                }, 1000); // Reduced timeout for quicker feedback
            } catch (error) {
                //console.error('There was an error fetching the data!', error);
            }
        };
        fetchDataHardstone();
    }, []);

    const initializeDataTable = (selector) => {
        // Check if DataTable is already initialized
        if ($.fn.DataTable.isDataTable(selector)) {
            $(selector).DataTable().destroy(); // Destroy existing DataTable instance
        }

        $(selector).DataTable({
            pagingType: "full_numbers",
            paging: true,
            searching: true,  // Disable default search
            info: true,
            lengthChange: false
        });
    };

    // Handle custom search
    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);

        // Apply search to both tables
        const ridgehillTable = $('#ridgehillPlots').DataTable();
        const hardstoneTable = $('#hardstonePlots').DataTable();

        ridgehillTable.search(query).draw();
        hardstoneTable.search(query).draw();
    };

    // Handle entries per page
    const handleEntriesPerPage = (event) => {
        const value = parseInt(event.target.value, 10);
        if(value === 1){
        //const value = parseInt(event.target.value, 10);
        //setEntriesPerPage(value);
        // Update page length for both tables
        $('#ridgehillPlots').DataTable().page.len(-1).draw();
    }
    else{        
        setEntriesPerPage(value);
        // Update page length for both tables
        $('#ridgehillPlots').DataTable().page.len(value).draw();
    }
    };

        // Handle entries per page
        const handleEntriesPerPageHardstone = (event) => {
            const value = parseInt(event.target.value, 10);            
            // Update page length for both tables            
            if(value === 1){
                //const value = parseInt(event.target.value, 10);
                //setEntriesPerPage(value);
                // Update page length for both tables
                $('#hardstonePlots').DataTable().page.len(-1).draw();
            }
            else{        
                setEntriesPerPageHardstone(value);   
                // Update page length for both tables
                $('#hardstonePlots').DataTable().page.len(value).draw();
            }
        };

    return (
        <main>
            {/* Navigation Bar */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
                <div className="container">
                    <a className="navbar-brand" href="/">Hardstone Properties</a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item" >
                                <a className="nav-link" href="/">Home</a>
                            </li>
                            <li className="nav-item" hidden>
                                <a className="nav-link" href="#">About</a>
                            </li>
                            <li className="nav-item" hidden>
                                <a className="nav-link" href="#">Contact</a>
                            </li>
                            <li className="nav-item">
                            <Link className="nav-link" to="/ForgotPassword" >Forgot Password ? </Link>
                            </li>
                        </ul>
                        <button className="btn btn-outline-light my-2 my-sm-0" data-toggle="modal" data-target="#modalLoginForm">Login</button>
                    </div>
                </div>
            </nav>

            <section id="home" className="mt-5 pt-3">
                <div className="container">
                    <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="view" style={{ backgroundImage: "url('images/hero_bg_3.jpg')", height: '100vh', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                    <div className="mask rgba-black-light"></div>
                                    <div className="container h-100 d-flex justify-content-center align-items-center">
                                        <div className="text-center" style={textContainerStyleSmall}>
                                            <h1 className="display-4 mb-4 white-text bold">Find Your Dream Home</h1>
                                            <p className="lead white-text">Explore our wide range of properties.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="view" style={{ backgroundImage: "url('images/hero_bg_2.jpg')", height: '100vh', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                    <div className="mask rgba-black-light"></div>
                                    <div className="container h-100 d-flex justify-content-center align-items-center">
                                        <div className="text-center white-text" style={textContainerStyleSmall}>
                                            <h1 className="display-4 mb-4 white-text bold">Invest in Real Estate</h1>
                                            <p className="lead white-text">Discover investment opportunities.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <div className="view" style={{ backgroundImage: "url('images/hero_bg_1.jpg')", height: '100vh', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                    <div className="mask rgba-black-light"></div>
                                    <div className="container h-100 d-flex justify-content-center align-items-center">
                                        <div className="text-center white-text" style={textContainerStyleSmall}>
                                            <h1 className="display-4 mb-4 white-text bold">Luxury Living Spaces</h1>
                                            <p className="lead white-text">Explore luxurious living options.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a className="carousel-control-prev" href="#carouselExampleSlidesOnly" role="button" data-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="sr-only">Previous</span>
                        </a>
                        <a className="carousel-control-next" href="#carouselExampleSlidesOnly" role="button" data-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <div className="container mt-5">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a className="nav-link active" id="home-tab" data-toggle="tab" href="#homeContent" role="tab" aria-controls="homeContent" aria-selected="true">Home</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="plots-tab" data-toggle="tab" href="#plotsContent" role="tab" aria-controls="plotsContent" aria-selected="false">Ridgehill Estate Plots</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" id="houses-tab" data-toggle="tab" href="#housesContent" role="tab" aria-controls="housesContent" aria-selected="false">Hardstone Estate Plots</a>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" id="homeContent" role="tabpanel" aria-labelledby="home-tab">
                        <section className="my-5">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-4 mb-4 d-flex">
                                        <div className="card flex-fill">
                                            <div className="card-body text-center">
                                                <i className="fas fa-home fa-4x mb-3"></i>
                                                <h4 className="card-title">Residential Properties</h4>
                                                <p className="card-text">Explore our selection of residential homes.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-4 d-flex">
                                        <div className="card flex-fill">
                                            <div className="card-body text-center">
                                                <i className="fas fa-building fa-4x mb-3"></i>
                                                <h4 className="card-title">Commercial Properties</h4>
                                                <p className="card-text">Browse through commercial real estate listings.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-4 d-flex">
                                        <div className="card flex-fill">
                                            <div className="card-body text-center">
                                                <i className="fas fa-landmark fa-4x mb-3"></i>
                                                <h4 className="card-title">Investment Opportunities</h4>
                                                <p className="card-text">Build lucrative investment properties.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="tab-pane fade" id="plotsContent" role="tabpanel" aria-labelledby="plots-tab">
                        <div className="container mt-5">
                            <h2>Ridgehill Estate Plots</h2>
                            <div className="d-flex justify-content-between mb-0">
                                <div>
                                    <label>Entries per page:</label>
                                    <select className="custom-select d-inline-block ml-2" onChange={handleEntriesPerPage}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={1}>All Entries</option>
                                    </select>
                                </div>
                                <div>
                                    <input type="hidden" className="form-control" placeholder="Search..." value={searchQuery} onChange={handleSearch} />
                                </div>
                            </div>
                            <table id="ridgehillPlots" className="display table table-striped table-bordered table-hover table-sm w-100">
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>Plot Number</th>
                                        <th>Size</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plotsRidgehill.map((plot, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{plot.plotNumberNew}</td>
                                            <td>{plot.plotAreasNew}</td>
                                            <td>{plot.plotPricesNew}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="housesContent" role="tabpanel" aria-labelledby="houses-tab">
                        <div className="container mt-5">
                            <h2>Hardstone Estate Plots</h2>
                            <div className="d-flex justify-content-between mb-0">
                                <div>
                                    <label>Entries per page:</label>
                                    <select className="custom-select d-inline-block ml-2" onChange={handleEntriesPerPageHardstone}>
                                       <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={1}>All Entries</option>
                                    </select>
                                </div>
                                <div>
                                    <input type="hidden" className="form-control" placeholder="Search..." value={searchQuery} onChange={handleSearch} />
                                </div>
                            </div>
                            <table id="hardstonePlots" className="display table table-striped table-bordered table-hover table-sm w-100">
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th>Plot Number</th>
                                        <th>Size</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plotsHardstone.map((plot, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{plot.plotNumberNew}</td>
                                            <td>{plot.plotAreasNew}</td>
                                            <td>{plot.plotPricesNew}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

          {/* Login Modal */}
<div className="modal fade" id="modalLoginForm" tabIndex="-1" role="dialog" aria-labelledby="modalLoginFormLabel" aria-hidden="true">
    <div className="modal-dialog" role="document">
        <div className="modal-content">
            <div>
           
            </div>
            <div className="card-header morpheus-den-gradient accent-2">
                <h5 className="modal-title white-text" id="modalLoginFormLabel">Login</h5>
                <button type="button" className="close red-text" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div className="modal-body">

            { loading ? (
                            <>
                        <div class="spinner-grow text-success"  role="status">
                        </div>
                        </>
                        ) : (<></>)
}

                <form onSubmit={handleLogin}>
               <MDBRow tag="form" className='g-3 text-left'>
                        <MDBCol md="12">
                        <label>Username</label>
                        <MDBInputGroup textBefore={<i class='fa fa-envelope prefix red-text'></i>} className='mb-3'>
        <input className='form-control' type='text' onChange={e => setUsername(e.target.value)} value={username} />
      </MDBInputGroup>
      </MDBCol>
      </MDBRow>
                        <MDBRow tag="form" className='g-3 text-left'>
                        <MDBCol md="12">
                          <label>Password</label>                     
      <MDBInputGroup className='mb-3' textBefore={<i class='fa fa-lock prefix red-text'></i>} textAfter= {showPassword ? <MDBIcon icon='eye-slash' style={{fontSize:'100%', color:'black'}} type='button' onClick={togglePasswordVisibility}/> : <MDBIcon icon='eye' type='button' onClick={togglePasswordVisibility} style={{fontSize:'100%', color:'red'}}/> }>
        <input type={showPassword ? "text" : "password"} className='form-control' onChange={e => setPassword(e.target.value)} value={password} />
      </MDBInputGroup>
      </MDBCol>
                     </MDBRow>

                    <button type="submit" className="btn btn-primary btn-block" disabled = {password === '' || username === ''}>
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>

        </main>
    );
};

export default Home;
